import { gql } from "graphql-request";

export const INSERT_EVENT = gql`
  mutation InsertEvent(
    $title: String!
    $description: String
    $singleDay: Boolean!
    $startTime: DateTime!
    $endTime: DateTime!
    $locationName: String!
    $meetingLink: String
    $locationLat: Float!
    $locationLng: Float!
    $categoryIds: [String!]!
    $coverImage: String
    $visibility: String!
    $registrationPolicy: String!
    $capacity: Int
    $groupIds: [String]
    $attachmentUrls: [String]
    $firstName: String!
    $lastName: String!
    $email: String!
    $profileImageUrl: String
  ) {
    insertevent(
      input: {
        title: $title
        description: $description
        singleDay: $singleDay
        startTime: $startTime
        endTime: $endTime
        locationName: $locationName
        meetingLink: $meetingLink
        locationLat: $locationLat
        locationLng: $locationLng
        categoryIds: $categoryIds
        coverImage: $coverImage
        visibility: $visibility
        registrationPolicy: $registrationPolicy
        capacity: $capacity
        groupIds: $groupIds
        attachmentUrls: $attachmentUrls
        eventOrganizerSnapshot: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          profileImageUrl: $profileImageUrl
        }
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;
export const GET_EVENTS = gql`
  query GetEvents(
    $where: eventFilterInput
    $order: [DynamicSortInput!]
    $pageNo: Int
    $pageSize: Int
  ) {
    getevents(
      where: $where
      order: $order
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationId
        Tags
        DeletedDate
        title
        description
        singleDay
        startTime
        endTime
        locationName
        meetingLink
        locationLat
        locationLng
        coverImage
        visibility
        registrationPolicy
        capacity
        categoryIds
        groupIds
        attachmentUrls
        eventOrganizerSnapshot {
          firstName
          lastName
          email
          profileImageUrl
        }
      }
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation UpdateEvent(
    $itemId: String!
    $title: String!
    $description: String!
    $singleDay: Boolean!
    $startTime: DateTime!
    $endTime: DateTime!
    $locationName: String!
    $meetingLink: String
    $locationLat: Float!
    $locationLng: Float!
    $categoryIds: [String!]!
    $coverImage: String
    $visibility: String!
    $registrationPolicy: String!
    $capacity: Int
    $groupIds: [String!]!
    $attachmentUrls: [String!]
  ) {
    updateevent(
      where: { ItemId: { eq: $itemId } }
      input: {
        title: $title
        description: $description
        singleDay: $singleDay
        startTime: $startTime
        endTime: $endTime
        locationName: $locationName
        meetingLink: $meetingLink
        locationLat: $locationLat
        locationLng: $locationLng
        categoryIds: $categoryIds
        coverImage: $coverImage
        visibility: $visibility
        registrationPolicy: $registrationPolicy
        capacity: $capacity
        groupIds: $groupIds
        attachmentUrls: $attachmentUrls
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_EVENT = gql`
  mutation DeleteEvent($itemId: String!) {
    deleteevent(
      where: { ItemId: { eq: $itemId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every event created by a user (used by the user-deletion purge).
export const DELETE_MANY_EVENT_BY_CREATOR = gql`
  mutation DeleteManyEventByCreator($createdBy: String!) {
    deleteManyevent(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;
// RSVP
export const GET_RSVPS = gql`
  query GetRSVPs(
    $where: RSVPFilterInput
    $order: [DynamicSortInput!]
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getRSVPs(
      where: $where
      order: $order
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationId
        Tags
        DeletedDate
        eventId
        status
        guestNames
        eventParticipantSnapshot {
          firstName
          lastName
          email
          profileImageUrl
        }
      }
    }
  }
`;

export const INSERT_RSVP = gql`
  mutation InsertRSVP(
    $eventId: String!
    $status: String!
    $firstName: String!
    $lastName: String!
    $email: String!
    $profileImageUrl: String
    $guestNames: [String]
  ) {
    insertRSVP(
      input: {
        eventId: $eventId
        status: $status
        guestNames: $guestNames
        eventParticipantSnapshot: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          profileImageUrl: $profileImageUrl
        }
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_RSVP = gql`
  mutation UpdateRSVP($itemId: String!, $status: String!) {
    updateRSVP(
      where: { ItemId: { eq: $itemId } }
      input: { status: $status }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_RSVP = gql`
  mutation DeleteRSVP($itemId: String!) {
    deleteRSVP(
      where: { ItemId: { eq: $itemId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every RSVP created by a user (used by the user-deletion purge).
export const DELETE_MANY_RSVP_BY_CREATOR = gql`
  mutation DeleteManyRSVPByCreator($createdBy: String!) {
    deleteManyRSVP(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;
// event gallery
export const GET_EVENT_GALLERY = gql`
  query GetEventGallery(
    $where: eventgalleryFilterInput
    $order: [DynamicSortInput!]
    $pageNo: Int!
    $pageSize: Int!
  ) {
    geteventgallerys(
      where: $where
      order: $order
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationId
        Tags
        DeletedDate
        eventId
        imageUrl
      }
    }
  }
`;

export const INSERT_EVENT_GALLERY = gql`
  mutation InsertEventGallery(
    $eventId: String!
    $imageUrl: String!
  ) {
    inserteventgallery(
      input: {
        eventId: $eventId
        imageUrl: $imageUrl
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_EVENT_GALLERY = gql`
  mutation DeleteEventGallery($itemId: String!) {
    deleteeventgallery(
      where: { ItemId: { eq: $itemId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every event gallery created by a user (used by the user-deletion purge).
export const DELETE_MANY_EVENT_GALLERY_BY_CREATOR = gql`
  mutation DeleteManyEventGalleryByCreator($createdBy: String!) {
    deleteManyeventgallery(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;
